import './email-header-display.scss';

import EmailHeaderDisplay from './EmailHeaderDisplay';

export default EmailHeaderDisplay;
